var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationRuleEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(2.325 13.305) scale(3.4127)",
    gradientUnits: "userSpaceOnUse",
    y2: 25.846,
    y1: 25.846,
    x2: 44.929,
    x1: 9.25,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7ab40",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4a73c",
    offset: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ed992f",
    offset: 0.671
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2861d",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(2.325 13.305) scale(3.4127)",
    gradientUnits: "userSpaceOnUse",
    y2: 44.356,
    y1: 6.948,
    x2: 26.58,
    x1: 5.988,
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eba84b",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d97218",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 25.846,
    y1: 25.846,
    x2: 44.929,
    x1: 9.25,
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7ab40",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4a73c",
    offset: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ed992f",
    offset: 0.671
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2861d",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 44.356,
    y1: 6.948,
    x2: 26.58,
    x1: 5.988,
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eba84b",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d97218",
    offset: 1
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M28 35.746c0 2.211-1.79 4-4 4s-4-1.789-4-4a4 4 0 0 1 8 0zM26 11a1.999 1.999 0 1 1-4 0V7a1.999 1.999 0 1 1 4 0Z",
    style: {
      fill: "#db8509"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 33V16.8a9 9 0 0 0-9-9 9 9 0 0 0-9 9V33Z",
    style: {
      fill: "#ffc107"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 33c0 2.21-7.059 4-17 4-9.941 0-17-1.79-17-4s7.059-4 17-4c9.941 0 17 1.79 17 4Z",
    style: {
      fill: "#ffc107"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 33c0-2 8-9 8-12s18-3 18 0 8 10 8 12-34 2-34 0Z",
    style: {
      fill: "#ffc107"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.746 27.666c-.817.968-.81.97-1.613 1.932 1.467.926 7.646 4.539 15.261 4.539 4.296 0 9.433-1.504 14.308-4.727-.867-1.047-.87-1.053-1.542-1.836-11.801 7.448-23.313 1.86-26.414.092z",
    style: {
      fill: "#ffe8a0",
      fillOpacity: 1,
      strokeWidth: 1.12972438
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    textAnchor: "none",
    fontSize: "none",
    fontWeight: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 172V0h172v172z",
    transform: "translate(24 22) scale(.13953)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M12.563 50.844h143.334v5.775l-59.108 45.9a20.48 20.48 0 0 1-25.118 0l-59.108-45.9Z",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.4127,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    transform: "translate(24 22) scale(.13953)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M12.563 49.138h143.334v5.774L94.352 99.66a17.017 17.017 0 0 1-20.244 0L12.563 54.912Z",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.4127,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    transform: "translate(24 22) scale(.13953)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m9 26 36-14.308V38a2 2 0 0 1-2 2H9Z",
    style: {
      fill: "url(#b)"
    },
    transform: "translate(24.324 23.618) scale(.47619)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M3 11.692V38a2 2 0 0 0 2 2h38a1.98 1.98 0 0 0 1.283-.478z",
    style: {
      fill: "url(#d)"
    },
    transform: "translate(24.324 23.618) scale(.47619)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.753 28.856h20v.806l-8.248 6.405c-1.03.8-2.473.8-3.504 0l-8.248-6.405Z",
    opacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.753 28.618h20v.806l-8.588 6.244a2.375 2.375 0 0 1-2.824 0l-8.588-6.244Z",
    opacity: 0.07
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fabb62",
    d: "M26.705 27.428h18.096c.526 0 .952.426.952.952v.806l-8.928 6.083a1.904 1.904 0 0 1-2.144 0l-8.928-6.083v-.806c0-.526.426-.952.952-.952Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationRuleEmail);
export default __webpack_public_path__ + "static/media/notificationRuleEmail.e6c0596ef8e9f87788a3d204288c6677.svg";
export { ForwardRef as ReactComponent };